// removed by extract-text-webpack-plugin
module.exports = {"Title":"_17BuKPZ89JaQY7shVUV4mg","NoPaddingTop":"_15zJOq48TEo3K3XZIKlmTR","Center":"_2zBkeMJ0_D3t5KCyANzY8f","Light":"_2G-JEKNeLumXaJkLtZliyJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Title/Title.css
// module id = 185
// module chunks = 0